import api from '../../utils/api';
import history from '../../utils/history';
import { alertError, alertSuccess } from './alert';
import Token from '../../utils/token';
import { authenticated } from './auth';
import { VALIDATED } from '../../constants/auth';

let cancelPassword;

const resendOtp = (email) => {
  if (cancelPassword) {
    cancelPassword('Cancel send password');
  }

  const resendOtpUrl = `/otp/resend?email=${email}`;
  return api.post(resendOtpUrl, {
    cancelToken: new api.CancelToken((c) => (cancelPassword = c)),
  });
};

export const resendEmailOtp = () => async (dispatch, getState) => {
  const { email } = getState().auth;

  try {
    const response = await resendOtp(email);
    if (response.data.success) {
      const message = (
        <>
          Resend email OTP was sent to <strong>{email}</strong>
        </>
      );
      dispatch(alertSuccess(message));
      history.push('/signin');
    }
  } catch (error) {
    dispatch(alertError(error));
  }
};

export const verifyEmailOtp = (otp) => async (dispatch, getState) => {
  const verifyOtpUrl = '/otp/verify';
  const { email } = getState().auth;
  const tokenObject = Token.getToken();
  if (!tokenObject || !tokenObject.access_token) {
    dispatch(alertError({ message: `No access token found` }));
    return;
  }

  const params = {
    email,
    otp,
    accessToken: tokenObject.access_token,
  };

  try {
    const response = await api.post(verifyOtpUrl, params);
    if (response.data.success) {
      dispatch(alertSuccess(`OTP was verified successfully`));
      dispatch(authenticated(VALIDATED));
    } else {
      dispatch(alertError({ message: `OTP is incorrect` }));
    }
  } catch (error) {
    dispatch(alertError(error));
  }
};
